'use client';

import { useState } from 'react';
import { ArrowLeft, Mail, Phone, MapPin, Send } from 'lucide-react';
import { useRouter } from 'next/navigation';
import Button from '@/ui/Button';
import AdsterraBanner from '@/components/AdsterraBanner';

export default function ContactPage() {
  const router = useRouter();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button
          variant="ghost"
          onClick={() => router.back()}
          className="mb-8 flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          Back
        </Button>

        <div className="mb-12">
          <h1 className="text-5xl sm:text-6xl font-bold text-foreground mb-4">
            Get In Touch
          </h1>
          <p className="text-xl text-muted max-w-2xl">
            Have questions or feedback? We&apos;d love to hear from you. Reach
            out to us anytime.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <AdsterraBanner position="top" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="lg:col-span-1">
            {/* Email */}

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center
                    justify-center flex-shrink-0">
                <Mail className="text-primary" size={20} />
              </div>
              <div>
                <h3 className="font-bold text-foreground mb-1">Email</h3>
                <p className="text-foreground/70">
                  helpdesk@minifanfictionverse.site
                </p>
              </div>
            </div>
          </div>

        </div>

        <AdsterraBanner position="bottom" />
      </div>
    </div>
  );
}
